import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { getCordovaReadyPromise } from '@utils/cordovaChecker'
import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'

declare let cordova: any

/**
 * Cross frame listener for bluetooth scan via cordova call.
 *
 *  @return {Promise} - Promise for the specified action.
 */
export async function getBluetoothScan () {

    return getCordovaReadyPromise().then(() => {
        const deferred = generateDeferredPromise<any>()
        cordova.exec(
            (response) => {
                deferred.resolve(response)
            },
            (error) => {
                deferred.reject(error)
            },
            'BluetoothReaderClient',
            'getBluetoothScan',
            [],
        )
        return deferred.promise
    }, () => {
        return PromiseUtils.newRejectedPromiseWithErrorMessage('Cordova is not available in this window.')
    })
}
